import { LOGOUT, SET_DAILY_MENU, SET_FULL_MENU } from "../actions/types";

const INITIAL_STATE = {
    daily: {
        menuID: null,
        date: null,
        content: {}
    },
    full: {
        menuID: null,
        dateFrom: null,
        dateTo: null,
        confirmed: null,
        content: {}
    }
};

const menuReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_DAILY_MENU:
            return {
                ...state,
                daily: {
                    menuID: action.payload.menuID,
                    date: action.payload.date,
                    content: mapObject(action.payload.content, mealGroup => {
                        return {
                            mealDescription: mealGroup.mealDescription,
                            categorySort: mealGroup.categorySort,
                            rows: mealGroup.rows.map(row => {
                                return {
                                    posID: row.posID,
                                    description: row.description
                                }
                            })
                        };
                    })
                }
            };
        case SET_FULL_MENU:
            return {
                ...state,
                full: {
                    menuID: action.payload.menuID,
                    dateFrom: action.payload.dateFrom,
                    dateTo: action.payload.dateTo,
                    confirmed: action.payload.confirmed,
                    content: mapObject(action.payload.content, weekDay => mapObject(weekDay, mealGroup => {
                        return {
                            mealDescription: mealGroup.mealDescription,
                            rows: mealGroup.rows.map(row => {
                                return {
                                    posID: row.posID,
                                    description: row.description
                                }
                            })
                        };
                    }))
                }
            };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

const mapObject = (source, action) => {
    const output = {};
    for (const key in source) {
        output[key] = action(source[key]);
    }
    return output;
};

export default menuReducer;